import axios from "axios";
import { Constant } from "../../config";

export default {
  _fetchSaleOrder: async (email, orderNo, page, limit = 10) => {
    const url = `${Constant.BASE_API}/quotation?page=${page}&limit=${limit}&order_no=${orderNo}&email=${email}`;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data;
  },
  _updateSaleOrder: async (payload) => {
    const url = `${Constant.BASE_API}/quotation/update/${payload.id}`;
    const opt = {
      url,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error };
    }

    return { error: false };
  },
  _submitSaleOrder: async (payload, sendKyc) => {
    const param = sendKyc ? `?kyc=true` : "";
    const url = `${Constant.BASE_API}/quotation${param}`;
    const opt = {
      url,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error };
    }

    return { error: false };
  },
  _checkMemberKyc: async (memberId) => {
    const url = `${Constant.BASE_API}/kyc-check/TxpmZ44u/${memberId}`;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return resp.data.error;
    }

    return resp.data;
  },
};



// WEBPACK FOOTER //
// ./src/containers/SaleOrder/service.js